const getTvChannelGroupIndex = (channelIndex: number, size: number): number => {
  if (size <= 0 || channelIndex < 0) {
    return 0;
  }
  return Math.floor(channelIndex / size);
};

export default getTvChannelGroupIndex;
